/* BIG SHOP — Filtro de preco na moeda selecionada (USD/BRL/PYG)
   A Shopify so filtra em USD (moeda da loja). Este script mostra os campos
   de preco na moeda escolhida no conversor do header e traduz de volta para
   USD por baixo dos panos (inputs hidden), sem mudar o funcionamento nativo.
   Reusa a preferencia e o cache de cotacao do currency-switcher.js. */
(function () {
  if (window.__bsPriceFilterInit) return;
  window.__bsPriceFilterInit = true;

  var PREF_KEY = 'preferred_currency';
  var CACHE_KEY = 'cp_fx_rates_v2';
  var SYMBOLS = { USD: '$', BRL: 'R$', PYG: '₲' };

  function getPreferred() {
    try { return localStorage.getItem(PREF_KEY) || 'USD'; } catch (e) { return 'USD'; }
  }

  function manualRates() {
    if (!window.__manualRatesEnabled) return null;
    var brl = parseFloat(window.__manualRateBRL);
    var pyg = parseFloat(window.__manualRatePYG);
    if (isNaN(brl) || isNaN(pyg)) return null;
    return { BRL: brl, PYG: pyg };
  }

  function cachedRates() {
    try {
      var stored = localStorage.getItem(CACHE_KEY);
      if (stored) return JSON.parse(stored);
    } catch (e) {}
    return null;
  }

  function getRate(code) {
    if (code === 'USD') return 1;
    var rates = manualRates() || cachedRates();
    if (rates && rates[code]) return rates[code];
    return null;
  }

  function parseNum(str) {
    if (str === null || str === undefined || str === '') return NaN;
    var s = String(str).replace(/\s/g, '');
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) {
      /* formato 1.234,56 -> ponto e milhar, virgula e decimal */
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.indexOf(',') > -1) {
      s = s.replace(',', '.');
    }
    return parseFloat(s);
  }

  /* Valor exibido: PYG inteiro; BRL/USD com 2 casas */
  function fmtDisplay(value, code) {
    if (code === 'PYG') return String(Math.round(value));
    return (Math.round(value * 100) / 100).toFixed(2);
  }

  /* Converte o valor digitado (moeda exibida) para USD com 2 casas */
  function toUsd(value, rate) {
    return String(Math.round((value / rate) * 100) / 100);
  }

  function setupInput(input, rate, code) {
    var hidden = input.__bsHidden;
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = input.getAttribute('name');
      hidden.value = input.value || '';
      input.removeAttribute('name');
      input.insertAdjacentElement('afterend', hidden);
      input.__bsHidden = hidden;

      /* guarda os originais em USD para nunca converter duas vezes */
      input.__bsMaxUsd = parseNum(input.getAttribute('data-max'));
      input.__bsPlaceholderUsd = parseNum(input.getAttribute('placeholder'));

      input.addEventListener('input', function () {
        var v = parseNum(input.value);
        hidden.value = isNaN(v) ? '' : toUsd(v, input.__bsRate || 1);
      });
    }

    input.__bsRate = rate;

    var usdVal = parseNum(hidden.value);
    input.value = isNaN(usdVal) ? '' : fmtDisplay(usdVal * rate, code);

    if (!isNaN(input.__bsMaxUsd)) {
      input.setAttribute('data-max', fmtDisplay(input.__bsMaxUsd * rate, code));
    }
    if (!isNaN(input.__bsPlaceholderUsd)) {
      input.setAttribute('placeholder', fmtDisplay(input.__bsPlaceholderUsd * rate, code));
    }
  }

  /* "O maior preco e $900.00" — converte o valor mantendo o texto */
  function setupMaxText(el, rate, code) {
    if (!el.__bsOriginal) el.__bsOriginal = el.textContent;
    var m = el.__bsOriginal.match(/([\d.,]+)/);
    if (!m) return;
    var usd = parseNum(m[1]);
    if (isNaN(usd)) return;
    el.textContent = el.__bsOriginal
      .replace(/[$₲]|R\$/g, '')
      .replace(m[1], SYMBOLS[code] + ' ' + fmtDisplay(usd * rate, code));
  }

  function apply() {
    var code = getPreferred();
    var rate = getRate(code);
    if (rate === null) return; /* cotacao ainda nao disponivel: mantem USD */

    document.querySelectorAll('price-range .field__input').forEach(function (input) {
      setupInput(input, rate, code);
    });

    document.querySelectorAll('price-range .field-currency, .facets__price .field-currency').forEach(function (span) {
      span.textContent = SYMBOLS[code];
    });

    document.querySelectorAll('.facets__selected, .mobile-facets__info').forEach(function (el) {
      if (/[\d]/.test(el.textContent)) setupMaxText(el, rate, code);
    });
  }

  function init() {
    apply();

    /* refaz apos o facets.js re-renderizar os filtros (AJAX) */
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        apply();
      }, 120);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    /* refaz quando o cliente troca a moeda no header */
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-currency-option]')) {
        setTimeout(apply, 60);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
